module.exports = __webpack_public_path__ + "img/resource_pkg2.ef8962a1.png";